// The DOM that sits around the canvas during a game: the move list beside or
// under the board. (The draw offer lives in the pause menu.)
import { sanPlies } from '../game/pgn.js';
import type { Move } from '../game/types.js';
import { MoveListPanel } from '../ui/MoveListPanel.js';
import type { SettingsManager } from '../settings/SettingsManager.js';
import type { SceneMode } from './SceneMode.js';

export class SceneChrome {
  private readonly moveList: MoveListPanel;
  /** The move array the list was last built from; a new move makes a new array. */
  private listed: readonly Move[] | null = null;

  constructor(canvas: HTMLCanvasElement, private readonly mode: SceneMode, private readonly settings: SettingsManager) {
    this.moveList = new MoveListPanel({ canvas });
  }

  /** The match state changed. */
  update(): void {
    const state = this.mode.match.state;
    if (state.moves !== this.listed) {
      this.listed = state.moves;
      this.moveList.setMoves(sanPlies(state));
    }
    this.frame();
  }

  /** Every frame: the list follows the canvas on screen, and the player's choice to show it at all. */
  frame(): void {
    this.moveList.setHidden(!this.settings.get().showMoveList);
    this.moveList.layout();
  }

  /** Language changed mid-game. */
  relabel(): void {
    this.moveList.relabel();
    this.frame();
  }

  dispose(): void {
    this.moveList.dispose();
  }
}
